export default __webpack_public_path__ + "ad808646ada78942cb82caa05ea28bc4.png";